import LegalDocument from "pages/components/LegalDocument";
import { useTranslation } from "react-i18next";
import {
  AGREEMENT_LAST_UPDATED,
  AGREEMENT_VERSION,
  agreementSections,
} from "./content";

/** Vendor Service Agreement. The text lives in content.tsx; this is layout only. */
const VendorAgreement: React.FC = () => {
  const { t } = useTranslation("legal");

  return (
    <LegalDocument
      title={t("common.agreement_title")}
      version={AGREEMENT_VERSION}
      lastUpdated={AGREEMENT_LAST_UPDATED}
      intro={t("common.agreement_intro")}
      sections={agreementSections(t)}
    />
  );
};

export default VendorAgreement;
